import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col',
    header: 'flex flex-wrap items-center justify-between gap-3',
    title: 'heading-italic-m md:heading-italic-l',
    list: 'mt-6 flex flex-col gap-10 md:mt-8',
    group: 'flex flex-col gap-3',
    date: 'heading-xs text-tertiary tracking-[0.04em] uppercase',
    cards: 'flex flex-col gap-3',
    empty: 'heading-m mt-4',
    loadMore: 'relative mt-6 flex min-h-10 items-center justify-center',
    loadMoreTrigger: 'absolute inset-0 h-px w-full'
  },
  variants: {
    variant: {
      page: {},
      drawer: {
        header: 'pr-10 sm:pr-0',
        title: 'heading-italic-m',
        list: 'mt-8 flex flex-col gap-5',
        group: 'flex flex-col gap-2.5',
        date: 'heading-xs text-primary normal-case tracking-normal',
        cards: 'flex flex-col gap-3'
      }
    }
  },
  defaultVariants: {
    variant: 'page'
  }
});
